export const getDaysInMonth = (
  month: number = 0,
  year: number = new Date().getFullYear()
) => new Date(year, month, 0).getDate();
